module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top",
    attrs: {
      "color-on-scroll": "100"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logowithname.png")
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right navbar-uppercase"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'restaurants'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Restaurants")])]), _vm._v(" "), (_vm.isUserLoggedIn) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'orders'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("My Orders")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'location'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Change Location")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Privacy")])]), _vm._v(" "), (!_vm.isUserLoggedIn) ? [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loginUser($event)
      }
    }
  }, [_vm._v("Log In")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signupUser($event)
      }
    }
  }, [_vm._v("Sign Up")])])] : [_c('router-link', {
    attrs: {
      "to": {
        name: 'my_account'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("My Account")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logoutUser($event)
      }
    }
  }, [_vm._v("Log Out")])])], _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'basket'
      },
      "tag": "li",
      "active-class": "active"
    }
  }, [_c('a', {
    staticClass: "text-info",
    attrs: {
      "href": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-basket"
  }), _vm._v(" "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.basketCount))])])])], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "id": "menu-toggle",
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#example"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar3"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-144f623a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Header.vue
// module id = 208
// module chunks = 14